import React, { useState, useEffect } from "react";
export const useTemporaryAlert = (duration = 3000) => {
  const [showSuccessAlert, setShowSuccessAlert] = useState(false);

  const showSuccess = () => {
    setShowSuccessAlert(true);

    setTimeout(() => {
      setShowSuccessAlert(false);
    }, duration);
  };

  useEffect(() => {
    return () => {
      setShowSuccessAlert(false);
    };
  }, []);

  return { showSuccess, showSuccessAlert };
};
